/****   http.js   ****/
// 导入封装好的axios实例
import request from './request'

const http ={
    /**
     * methods: 请求
     * @param url 请求地址
     * @param params 请求参数
     */
    get(url,params){
        const config = {
            method: 'get',
            url:url
        }
        if(params) config.params = params
        return request(config)
    },
    post(url,params,hasFile){
      // console.log(url)
        const config = {
            method: 'post',
            url:url,
            hasFile:''
        }
        if(hasFile) config.hasFile = hasFile
        if(params) config.data = params
        return request(config)
    },
    postUrl(url,params,hasFile){
      // console.log(url)
      const config = {
        method: 'post',
        url:url,
        hasFile:''
      }
      if(hasFile) config.hasFile = hasFile
      if(params) config.params = params
      return request(config)
    },
    download(url) {
        return request({
          url: url,
          method: 'get',
          responseType: 'blob'
        })
    },
   downloadPost(url,data) {
    return request({
      url: url,
      method: 'post',
      data:data,
      responseType: 'blob'
    })
  }
}
//导出
export default http



// WEBPACK FOOTER //
// ./src/util/http.js